<div style=" margin-top: 6.5%;display: flex;width: 100%;">
  <app-jsip-left-pannel (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
  <div class="topDiv_with_LPannel" style="overflow: auto;" [class.collapsed]="!isSidenavOpen">
    <app-jsip-product-info-bar></app-jsip-product-info-bar>
   
  <div class="label-bar">
    <button
      *ngIf="showWorkflow"
      style="margin: 0 0 10px 0"
      mat-icon-button
      (click)="cancelWorkflow()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <label
      *ngIf="!showWorkflow"
      i18n="@@spmsUserReg"
      class="textColour"
      style="font-size: 20px; font-weight: 500"
      >{{ pageTitle }}
    </label>
    <label
      *ngIf="showWorkflow"
      i18n="@@spmsUserReg"
      class="textColour"
      style="font-size: 20px; font-weight: 500"
      >{{ selectedSignal?.product
      }}<span
        class="badge text-bg-secondary"
        *ngIf="showWorkflow"
        style="
          box-shadow: none !important;
          color: #3e3636 !important;
          background: #e3f2fd !important;
          margin: 5px !important;
          font-size: 10px !important;
          padding: 5px !important;
          border-radius: 5px !important;
          margin-left: 10px !important;
          font-weight: 500;
        "
        >{{ pageTitle }}</span
      ></label
    >

    <span class="example-spacer"></span>
    <app-common-button
      *ngIf="!showWorkflow"
      title="Refresh"
      icon="fas fa-sync-alt"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onRefresh()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
    <app-common-button
      icon="fas fa-download"
      *ngIf="!showWorkflow"
      title="Download "
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onDownload()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>

    <app-common-button
      *ngIf="!showWorkflow"
      label="Create"
      title="Create Signal"
      icon="fas fa-plus-circle"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      [critical]="true"
      (clicked)="onCreate()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
    <app-common-button
      *ngIf="showWorkflow"
      icon="fas fa-angle-double-right"

      title="Complete"
      [buttonId]="1111"
      width="50px"
      [critical]="true"
      (clicked)="onCompleteClick()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
  </div>
  <!-- STATS -->
  <div *ngIf="!showWorkflow" class="summary-row">

    <div class="summary-card">
      <span class="label">Signal Detected</span>
      <span class="value">{{ totaldetectedCount }}</span>
    </div>

    <div class="summary-card">
      <span class="label">Signal Validated</span>
      <span class="value">{{ totalSignalValidated }}</span>
    </div>

    <div class="summary-card">
      <span class="label">Signal Assessed</span>
      <span class="value">{{ signalAssessed }}</span>
    </div>

    <div class="summary-card">
      <span class="label">Signal Communicated</span>
      <span class="value">{{ signalCommunicated }}</span>
    </div>

        <div class="summary-card">
      <span class="label">Total Signals</span>
      <span class="value">{{ totalCount }}</span>
    </div>
  </div>

  <div *ngIf="!showWorkflow" style="width: 100%; margin-bottom: 5%">
    <ag-grid-angular
      style="margin-top: 2%; height: 55vh"
      class="ag-theme-balham"
      [rowData]="rowData"
      [components]="components"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
      [suppressRowClickSelection]="true"
      [animateRows]="true"
      [paginationPageSize]="10"
      (gridReady)="onGridReady($event)"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
       [pagination]="true"

    >
    </ag-grid-angular>
  </div>

  <div *ngIf="showWorkflow" class="workflow-content">
    <app-workflow-steps
      *ngIf="showWorkflow"
      [steps]="steps"
      [activeIndex]="activeIndex"
      [completedSteps]="completedSteps"
      [clickable]="false"
      (stepChange)="onStepChange($event)"
    >
    </app-workflow-steps>
    <mat-accordion multi="false" class="workflow-accordion">
      <!-- DETAILS (Open by default) -->
      <mat-expansion-panel
        [expanded]="true"
        style="box-shadow: none; border: 1px solid #ccc; margin-bottom: 1%"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Details<span class="example-spacer"></span>
            <!-- EDIT ICON -->
            <mat-icon
              *ngIf="!isEditMode"
              class="action-icon edit"
              matTooltip="Edit"
              (click)="enableEdit(); $event.stopPropagation()"
            >
              edit
            </mat-icon>

            <!-- SAVE ICON -->
            <mat-icon
              *ngIf="isEditMode"
              class="action-icon save"
              matTooltip="Save"
              (click)="saveDetails(); $event.stopPropagation()"
            >
              check
            </mat-icon>

            <!-- CANCEL ICON -->
            <mat-icon
              *ngIf="isEditMode"
              class="action-icon cancel"
              matTooltip="Cancel"
              (click)="cancelEdit(); $event.stopPropagation()"
            >
              close
            </mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <app-signal-details
          [selectedSignal]="selectedSignal"
          [signalId]="selectedSignal?.id"
          [stepId]="steps[activeIndex]?.stepId"
          [isEditMode]="isEditMode"
        >
        </app-signal-details>
      </mat-expansion-panel>

      <!-- DECISION -->
      <mat-expansion-panel
        style="box-shadow: none; border: 1px solid #ccc; margin-bottom: 5%"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> Decision </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-tab-group [(selectedIndex)]="selectedTabIndex"  mat-stretch-tabs="false">
          <mat-tab label="Decision">
            <app-signal-decision
              [signalId]="selectedSignal?.id"
              [stepId]="steps[activeIndex]?.stepId"
            >
            </app-signal-decision>
          </mat-tab>
          <mat-tab label="Attachment">
            <app-signal-attachment
              [signalId]="selectedSignal?.id"
              [stepId]="steps[activeIndex]?.stepId"
              [selectedSignal]="selectedSignal"
            >
            </app-signal-attachment>
          </mat-tab>
        </mat-tab-group>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  </div>
